import { ISchedule } from '../../../types/mealtimes.types';
import { capitalise } from '../../../helpers/capitalise';

interface IGroupedSchedule {
  startDay: string;
  endDay: string | null;
  time: string;
}

export const groupAndFormatSchedules = (schedules: ISchedule[]): IGroupedSchedule[] => {
  const groupedSchedules: IGroupedSchedule[] = [];

  schedules
    .filter((schedule) => schedule.enabled)
    .forEach((schedule) => {
      const time = `${schedule.start_time}-${schedule.end_time}`;
      const prevGroup = groupedSchedules.slice(-1)[0];

      if (prevGroup && prevGroup.time === time) {
        const removedGroup = groupedSchedules.pop();
        groupedSchedules.push({ ...removedGroup, endDay: capitalise(schedule.day_of_week.slice(0, 3)) });
      } else {
        groupedSchedules.push({
          startDay: capitalise(schedule.day_of_week.slice(0, 3)),
          endDay: null,
          time: `${schedule.start_time}-${schedule.end_time}`,
        });
      }
    });
  return groupedSchedules;
};
